export default "__VITE_ASSET__CETbTZa9__"